import React from "react";
import Button from "@mui/material/Button";
import RefreshIcon from "@mui/icons-material/Refresh";

/**
 * Error boundary for PDF preview / iframe sections.
 */
class PDFErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    // Log error for debugging but don't crash the app
    console.error("PDF rendering error:", error, errorInfo);

    if (error?.message?.includes("Config")) {
      console.info("Possible HMR issue during development; a full page refresh may help.");
    }
  }

  handleRetry = () => {
    this.setState({ hasError: false, error: null });
  };

  handleRefresh = () => {
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      return (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            padding: "40px",
            backgroundColor: "#f8f9fa",
            borderRadius: "8px",
            border: "1px solid #dee2e6",
            minHeight: "300px",
            textAlign: "center",
          }}
        >
          <img
            src="/assets/img/reports/pdf-error.svg"
            alt="PDF Error"
            style={{ width: "80px", marginBottom: "20px", opacity: 0.6 }}
            onError={(e) => {
              e.target.style.display = "none";
            }}
          />
          <h3 style={{ color: "#495057", marginBottom: "10px", fontSize: "18px" }}>
            Unable to render PDF preview
          </h3>
          <p style={{ color: "#6c757d", marginBottom: "20px", maxWidth: "400px" }}>
            A temporary rendering issue occurred. This is typically resolved by refreshing the page.
          </p>
          <div style={{ display: "flex", gap: "10px" }}>
            <Button
              variant="outlined"
              onClick={this.handleRetry}
              style={{ textTransform: "none" }}
            >
              Try Again
            </Button>
            <Button
              variant="contained"
              onClick={this.handleRefresh}
              startIcon={<RefreshIcon />}
              style={{
                backgroundColor: "#407775",
                textTransform: "none",
              }}
            >
              Refresh Page
            </Button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default PDFErrorBoundary;
